import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import Routes from './routes'; 
import 'bootstrap/dist/css/bootstrap.min.css';
import { AlertProvider } from './context/AlertContext'; 
import {
  fetchCoachesMin,
  fetchNutritionList,
  fetchUnitsList,
  fetchMealTypesList,
  fetchVideoCategoriesList,
  fetchExercisesCategoriesMin
} from './redux/slices/optionsSlice';

const App = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const { planActive } = useSelector((state) => state.apiResponses);

  useEffect(() => {
    if (!planActive && location.pathname != '/configuration' && location.pathname != '/forgot-password' &&
     location.pathname != '/' && location.pathname != '/verify-otp' && location.pathname != '/reset-password' && location.pathname != '/login') {
      navigate('/subscription');
    } else {
      setIsLoading(false);
    }
  }, [planActive, location.pathname, navigate]);

  const { isAuthenticated } = useSelector((state) => state.protect);
   
  useEffect(() => {
    if (isAuthenticated) {
      dispatch(fetchCoachesMin());
      dispatch(fetchNutritionList());
      dispatch(fetchUnitsList());
      dispatch(fetchMealTypesList());
      dispatch(fetchVideoCategoriesList());
      dispatch(fetchExercisesCategoriesMin());
    }
  }, [dispatch, isAuthenticated]);

  if (isLoading) {
    return null;
  }      
  return (    
    <AlertProvider>
      <Routes />
    </AlertProvider>
  );
};

export default App;